import type { Theme } from '@mui/material';

export const styles = {
  feedbackForm: (theme: Theme) => ({
    maxWidth: '22rem',
    color: theme.colors.neutral[800],
    border: 1,
    borderColor: theme.colors.neutral[100],
    borderRadius: '0 1.25rem 1.25rem 1.25rem',
    p: 2.25,
    ml: 8,
  }),

  submitButton: (theme: Theme) => ({
    color: theme.colors.white,
    backgroundColor: theme.colors.primary[500],
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 700,
    '&:disabled': {
      color: theme.colors.neutral[200],
      backgroundColor: theme.colors.neutral[50],
    },
    '&.MuiButtonBase-root:hover': {
      backgroundColor: theme.colors.primary[600],
    },
  }),

  cancelButton: (theme: Theme) => ({
    color: theme.colors.primary[500],
    backgroundColor: theme.colors.white,
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 700,
    '&.MuiButtonBase-root:hover': {
      color: theme.colors.primary[600],
      backgroundColor: theme.colors.primary[50],
    },
  }),

  checkbox: {
    px: 1.5,
    flexShrink: 0,
  },
};
